import React, { useState, useEffect, useRef } from "react";
import './ChatBox.css';

import { MdClose } from 'react-icons/md';
import { HiHome } from 'react-icons/hi';
import { MdMic } from 'react-icons/md';
import { MdMicOff } from 'react-icons/md';
import { MdOutlineAttachFile } from 'react-icons/md';
import { MdVolumeUp } from 'react-icons/md';
import { MdVolumeOff } from 'react-icons/md';
import { MdSend } from 'react-icons/md';

import MessageFromBotCard from "../MessageFromBotCard/MessageFromBotCard";
import MessageFromUserCard from "../MessageFromUserCard/MessageFromUserCard";

import { MdOutlineSupportAgent } from "react-icons/md";
import { BsRobot } from "react-icons/bs";

import data from '../../data/data';

// This is a chatbox component where user can chat or ask query 

const ChatBox = (props) => {

    const [unmute, setUnmute] = useState(true); // this is use to toggle voice response
    const [onMic, setOnMic] = useState(false); // this is use to toggle voice input
    const [botCloseConfimation, setBotCloseConfimation] = useState(false); // this is use to toggle close chatbot popup
    const [chatWithAgent, setChatWithAgent] = useState(false); // this is use to toggle between agent and chatbot

    const BotFileInput = useRef(null) // this is reference to chatbot document upload
    const AgentFileInput = useRef(null) // this is reference to agent document upload
    const userInput = useRef(null) // this is reference to input field of both agent and chatbot

    // below state is use to store chats in form of array
    let [chatHistory, setChatHistory] = useState([
        <MessageFromBotCard
            key="0"
            msg={data["Home"].msg}
            utterance={data["Home"].utterance}
            isVoice={unmute}
            type={data["Home"].type}
            option={data["Home"].option}
            prompt={data["Home"].prompt}
            selectOption={(response) => { UserResponse(data["Home"].type, response, "", "", "") }}
        />
    ]);

    // below function is use for bot reponse. Currently bot show normal msg and error msg, but this is for demo purpose
    // in actual bot validation is given in backend so no need to check if error msg or not
    // we need to call an api where this function provide keyword selected by user or input given by user in api call and then accordingly
    // provide response in FromBot component
    function BotResponse(type, userMsg) {
        setTimeout(() => {
            if (type !== "err") {
                setChatHistory(chatHistory => [...chatHistory,
                <MessageFromBotCard
                    key={chatHistory.length}
                    msg={userMsg.msg}
                    utterance={userMsg.utterance}
                    isVoice={unmute}
                    type={userMsg.type}
                    option={userMsg.option}
                    prompt={userMsg.prompt}
                    selectOption={(response) => { UserResponse(userMsg.type, response, "", "", "") }}
                />
                ])
                // console.log(userMsg.type)
            }
            else {
                setChatHistory(chatHistory => [...chatHistory,
                <MessageFromBotCard
                    key={chatHistory.length}
                    msg={userMsg}
                    utterance={userMsg}
                    isVoice={unmute}
                    type="msg"
                    option={""}
                    prompt={{ "type": "", "name": "", "option": [] }}
                    selectOption={(response) => { UserResponse(userMsg.type, response, "", "", "") }}
                />
                ])

            }
        }, 1000);
    }

    function UserResponse(type, msg, ext, size, file, next) {
        // console.log(file)
        setChatHistory(chatHistory => [...chatHistory, <MessageFromUserCard type={type} ext={ext} msg={msg} uploadedFile={file} key={chatHistory.length} />])
        // console.log( msg )
        if (chatWithAgent) {
            return null
        }
        else {
            console.log("agent is false")
            if (type === "image" || type === "application" || type === "video" || type === "text") {
                if (ext === "png" || ext === "jpeg" || ext === "pdf" || ext === "jpg") {
                    if (size < 5000000) {
                        // call for api for OCR
                        BotResponse("msg", data["Uploaded document"])
                        // `console.log`("doc success")
                    }
                    else {
                        // console.log("doc size fail")
                        BotResponse("err", ["You have uploaded file of " + ((size) / (1024 * 1024)).toFixed(2) + "MB. Please upload file having file size of less than 5MB."])
                    }
                }
                else {
                    // console.log("doc type fail")
                    BotResponse("err", ["You have uploaded " + ext + " file whicg is invalid. Please upload file in image or PDF format. File with .jpeg, .jpg, .png, .pdf extension."])
                }
            }
            else if (data.hasOwnProperty(msg)) {
                // console.log("User response sent is " + msg)
                BotResponse("msg", data[msg])
            }
            else {
                // console.log("User response sent is " + next)
                BotResponse("msg", data["confuse"])
            }
        }
    }

    function refreshBot() {
        setChatHistory([
            <MessageFromBotCard
                key={"refresh" + chatHistory.length}
                msg={data["Home"].msg}
                utterance={data["Home"].utterance}
                isVoice={unmute}
                type={data["Home"].type}
                option={data["Home"].option}
                prompt={data["Home"].prompt}
                selectOption={(response) => { UserResponse(data["Home"].type, response, "", "", "") }}
            />
        ]);
    }

    function voiceInput() {
        if (window.hasOwnProperty('webkitSpeechRecognition')) {
            var recognition = new window.webkitSpeechRecognition();

            recognition.continuous = false;
            recognition.interimResults = false;
            recognition.lang = 'en-US';
            recognition.start();
            // console.log(chatHistory[chatHistory.length-1])
            recognition.onresult = function (e) {
                let result = e.results[0][0].transcript;
                console.log(e.results)
                // chatHistory[chatHistory.length-1].props.type = "msg"
                setOnMic(false)
                UserResponse("msg", result[0].toUpperCase() + result.slice(1), "", "", "")
                recognition.stop();
            };
            recognition.onerror = function (e) {
                setOnMic(false)
                BotResponse("err", ["You have " + e.error + " error. kindly check your network connectivity and try again."])
                recognition.stop();
            };
        }
        else {
            setChatHistory(chatHistory => [...chatHistory,
            <MessageFromBotCard
                key={chatHistory.length}
                msg={"Your browser does not support voice input. Kindly open in chrome"}
                utterance={"Your browser does not support voice input. Kindly open in chrome"}
                isVoice={unmute}
                type="msg"
                option={""}
                prompt={false}
                selectOption={(response) => { UserResponse("", response, "", "", "") }}
            />
            ])
        }
    }

    useEffect(() => {
        return () => {
            // cleanup
            // console.log(chatHistory)
            window.speechSynthesis.cancel()
        };
    }, [chatHistory, unmute]);

    console.log("Chatbox render")

    return (
        <div className="bot-chatbox">
            <div className="bot-chatbox-header">
                <div className="bot-chatbox-header-title">
                    <div className="bot-icon-btn">
                        <BsRobot className="avatar-icon" />
                    </div>
                    <div>
                        <div className="chatbot-name">{data["bot-name"]}</div>
                        <div className="chatbot-status">{data["status"]}</div>
                    </div>
                </div>
                <div className="bot-chatbox-header-close" onClick={() => { botCloseConfimation ? setBotCloseConfimation(false) : setBotCloseConfimation(true) }}><MdClose /></div>
            </div>
            <div className="bot-chatbox-main" >
                {chatHistory}
            </div>
            <div className="bot-chatbox-btns">
                {
                    chatWithAgent ?
                        <div className="chat-user-response-cont">
                            <div className="bot-chatbox-btn" onClick={() => { setChatWithAgent(false); UserResponse("agent", "End chat", "", "", "") }}>
                                <HiHome />
                            </div>
                            <input className="chat-user-response" autoFocus onKeyDown={(e) => { if (e.key === "Enter") { document.getElementById("chat-send").click(); } }} ref={userInput} type={"text"} placeholder="Type your response here." />
                            <label className="bot-chatbox-btn" id="attachment" htmlFor="bot-file-input" >
                                <MdOutlineAttachFile />
                            </label>
                            <input ref={AgentFileInput} id="bot-file-input" type="file" onChange={() => {
                                let docType = AgentFileInput.current.files.item(0).type
                                let docName = AgentFileInput.current.files.item(0).name
                                let docSize = AgentFileInput.current.files.item(0).size
                                UserResponse((docType).split("/")[0], docName, (docType).split("/")[1], docSize, AgentFileInput.current.files[0], "")
                            }} />
                            <button id="chat-send" onClick={() => { if (userInput.current.value !== "") { UserResponse("msg", userInput.current.value); userInput.current.value = "" } }}><MdSend /></button>
                        </div>
                        :
                        <>
                            <div className="bot-chatbox-btn" onClick={() => { refreshBot() }}>
                                <HiHome />
                            </div>
                            <div
                                className={onMic ? "bot-chatbox-btn btn-active" : "bot-chatbox-btn"}
                                onClick={() => {
                                    if (onMic) {
                                        setOnMic(false)
                                    }
                                    else {
                                        setOnMic(true)
                                        voiceInput()
                                    }
                                }}
                            >
                                {onMic ? <MdMic /> : <MdMicOff />}
                            </div>
                            <div
                                className={chatWithAgent ? "bot-chatbox-btn  btn-active" : "bot-chatbox-btn"}
                                onClick={() => {
                                    UserResponse("agent", "Agent_support", "", "", "")
                                    // console.log(chatHistory[chatHistory.length-1])
                                    setChatWithAgent(true)
                                }}
                            >
                                <MdOutlineSupportAgent />
                            </div>
                            <label className="bot-chatbox-btn" id="attachment" htmlFor="bot-file-input" >
                                <MdOutlineAttachFile />
                            </label>
                            <div
                                className={unmute ? "bot-chatbox-btn  btn-active" : "bot-chatbox-btn"}
                                onClick={() => { unmute ? setUnmute(false) : setUnmute(true) }}
                            >
                                {unmute ? <MdVolumeUp /> : <MdVolumeOff />}
                            </div>
                            <input ref={BotFileInput} id="bot-file-input" autoFocus type="file" onChange={(e) => {
                                // console.log(e.target.files[0])
                                let docType = BotFileInput.current.files.item(0).type
                                let docName = BotFileInput.current.files.item(0).name
                                let docSize = BotFileInput.current.files.item(0).size
                                // console.log(BotFileInput.current.files[0])
                                UserResponse((docType).split("/")[0], docName, (docType).split("/")[1], docSize, BotFileInput.current.files[0], "")
                            }} />
                        </>
                }
            </div>
            {
                botCloseConfimation ?
                    <>
                        <div className="bot-confirm-backdrop"></div>
                        <div className="bot-close-confirm-popup">
                            <div className="bot-close-confirm-msg">If you close chatbox then your chat history will be deleted. Do you want to close?</div>
                            <div className="bot-close-confirm-btn">
                                <button className="bot-close-confirm-close" onClick={() => { props.close(false) }}>Yes</button>
                                <button className="bot-close-confirm-cancle" onClick={() => { props.close(true); setBotCloseConfimation(false) }} >No</button>
                            </div>
                        </div>
                    </>
                    :
                    null
            }
        </div>
    )
}

export default ChatBox;
